import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';

const profile: AppRouteModule = {
  path: RouteEnum.PROFILE,
  name: RouteEnum.PROFILE,
  component: LAYOUT,
  redirect: RouteEnum.PROFILE_INDEX,
  meta: {
    hideChildrenInMenu: true,
    icon: 'ant-design:user-outlined',
    title: t('routes.profile.profile'),
    orderNo: 20,
    hideMenu: true,
  },
  children: [
    {
      path: 'index',
      name: RouteEnum.PROFILE_INDEX,
      component: () => import('/@/views/profile/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
        hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.PROFILE_INDEX,
      },
    },
  ],
};

export default profile;
